module.exports = __webpack_public_path__ + "media/images/countryrect/mx-fa2514909a5768ad3d23fd8863f9c7f0.svg";